import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import {
  IconHome,
  IconBuilding,
  IconUsers,
  IconCategory,
  IconCalendarEvent,
  IconBuildingWarehouse,
  IconSchool,
  IconMessage,
  IconMessageCircle,
  IconMedal,
  IconBuildingBank,
  IconSwimming,
  IconCoin,
  IconLogin,
  IconLogout,
  IconUserPlus,
  IconChartBar,
} from '@tabler/icons-react';

// ページタイトルとパンくずリストのマッピング
const PAGE_CONFIG: Record<string, {
  title: string;
  icon?: React.ReactNode;
  breadcrumbs?: { label: string; path?: string }[]
}> = {
  '/dashboard': {
    title: 'ダッシュボード',
    icon: <IconHome size={20} />,
    breadcrumbs: [{ label: 'ダッシュボード' }],
  },
  '/master/stores': {
    title: '店舗管理',
    icon: <IconBuilding size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '店舗管理' },
    ],
  },
  '/master/stores/new': {
    title: '新規店舗登録',
    icon: <IconBuilding size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '店舗管理', path: '/master/stores' },
      { label: '新規登録' },
    ],
  },
  '/master/staffs': {
    title: 'スタッフ管理',
    icon: <IconUsers size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: 'スタッフ管理' },
    ],
  },
  '/master/program-categories': {
    title: 'プログラムカテゴリ管理',
    icon: <IconCategory size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: 'プログラムカテゴリ管理' },
    ],
  },
  '/master/programs': {
    title: 'プログラム管理',
    icon: <IconCalendarEvent size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: 'プログラム管理' },
    ],
  },
  '/master/facilities': {
    title: '施設管理',
    icon: <IconBuildingWarehouse size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '施設管理' },
    ],
  },
  '/master/grades': {
    title: '級マスタ管理',
    icon: <IconMedal size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '級マスタ管理' },
    ],
  },
  '/master/schools': {
    title: '学校マスタ管理',
    icon: <IconSchool size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '学校マスタ管理' },
    ],
  },
  '/master/banks': {
    title: '金融機関マスタ管理',
    icon: <IconBuildingBank size={20} />,
    breadcrumbs: [
      { label: 'マスター管理', path: '/master' },
      { label: '金融機関マスタ管理' },
    ],
  },
  '/billing': {
    title: '請求サイクル管理',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理' },
    ],
  },
  '/billing/cycles/new': {
    title: '新規請求サイクル登録',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理', path: '/billing' },
      { label: '請求サイクル管理', path: '/billing' },
      { label: '新規登録' },
    ],
  },
  '/billing/adjustments': {
    title: '料金調整マスタ',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理', path: '/billing' },
      { label: '料金調整マスタ' },
    ],
  },
  '/billing/adjustments/new': {
    title: '新規料金調整登録',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理', path: '/billing' },
      { label: '料金調整マスタ', path: '/billing/adjustments' },
      { label: '新規登録' },
    ],
  },
  '/discount-groups': {
    title: 'グループマスタ',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理', path: '/billing' },
      { label: 'グループマスタ' },
    ],
  },
  '/discount-groups/new': {
    title: '新規グループ登録',
    icon: <IconCoin size={20} />,
    breadcrumbs: [
      { label: '請求管理', path: '/billing' },
      { label: 'グループマスタ', path: '/discount-groups' },
      { label: '新規登録' },
    ],
  },
  '/entry-exit/check-in': {
    title: '入室',
    icon: <IconLogin size={20} />,
    breadcrumbs: [
      { label: '入退室管理', path: '/entry-exit' },
      { label: '入室' },
    ],
  },
  '/entry-exit/check-out': {
    title: '退室',
    icon: <IconLogout size={20} />,
    breadcrumbs: [
      { label: '入退室管理', path: '/entry-exit' },
      { label: '退室' },
    ],
  },
  '/entry-exit/current-status': {
    title: '滞在状況',
    icon: <IconLogin size={20} />,
    breadcrumbs: [
      { label: '入退室管理', path: '/entry-exit' },
      { label: '滞在状況' },
    ],
  },
  '/customers': {
    title: '顧客管理',
    icon: <IconUsers size={20} />,
    breadcrumbs: [{ label: '顧客管理' }],
  },
  '/customers/new': {
    title: '新規顧客登録',
    icon: <IconUsers size={20} />,
    breadcrumbs: [
      { label: '顧客管理', path: '/customers' },
      { label: '新規登録' },
    ],
  },
  '/schools': {
    title: 'スクール管理',
    icon: <IconSchool size={20} />,
    breadcrumbs: [{ label: 'スクール管理' }],
  },
  '/communication/board': {
    title: 'コミュニケーションボード',
    icon: <IconMessage size={20} />,
    breadcrumbs: [
      { label: 'コミュニケーション', path: '/communication' },
      { label: 'ボード' },
    ],
  },
  '/communication/chat': {
    title: 'チャット',
    icon: <IconMessageCircle size={20} />,
    breadcrumbs: [
      { label: 'コミュニケーション', path: '/communication' },
      { label: 'チャット' },
    ],
  },
  '/bulletin-boards': {
    title: '掲示板',
    icon: <IconMessage size={20} />,
    breadcrumbs: [{ label: '掲示板' }],
  },
  '/bulletin-boards/new': {
    title: '新規掲示板作成',
    icon: <IconMessage size={20} />,
    breadcrumbs: [
      { label: '掲示板', path: '/bulletin-boards' },
      { label: '新規作成' },
    ],
  },
  '/chat': {
    title: 'チャット',
    icon: <IconMessageCircle size={20} />,
    breadcrumbs: [{ label: 'チャット' }],
  },
  '/chat/new': {
    title: '新規チャットルーム作成',
    icon: <IconMessageCircle size={20} />,
    breadcrumbs: [
      { label: 'チャット', path: '/chat' },
      { label: '新規作成' },
    ],
  },
  '/lane-assignment/class-lanes': {
    title: 'クラス別レーン配置',
    icon: <IconSwimming size={20} />,
    breadcrumbs: [
      { label: 'スクール管理', path: '/school-management' },
      { label: 'クラス別レーン配置' },
    ],
  },
  '/school-management/grades': {
    title: '級管理ダッシュボード',
    icon: <IconMedal size={20} />,
    breadcrumbs: [
      { label: 'スクール管理', path: '/school-management' },
      { label: '級管理ダッシュボード' },
    ],
  },
  '/customer-pre-registrations': {
    title: '事前登録管理',
    icon: <IconUserPlus size={20} />,
    breadcrumbs: [{ label: '事前登録管理' }],
  },
  '/customer-pre-registrations/new': {
    title: '新規事前登録',
    icon: <IconUserPlus size={20} />,
    breadcrumbs: [
      { label: '事前登録管理', path: '/customer-pre-registrations' },
      { label: '新規登録' },
    ],
  },
  // ========== レポート機能 ==========
  '/reports/daily': {
    title: '日次運営サマリ（日報）',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '日次運営サマリ（日報）' },
    ],
  },
  '/reports/sales': {
    title: '売上・財務レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '売上・財務レポート' },
    ],
  },
  '/reports/sales-transition': {
    title: '売上推移表',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '売上推移表' },
    ],
  },
  '/reports/member-achievement': {
    title: '入退会達成率レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '入退会達成率レポート' },
    ],
  },
  '/reports/members': {
    title: '会員動態レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '会員動態レポート' },
    ],
  },
  '/reports/programs': {
    title: 'プログラム効率レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: 'プログラム効率レポート' },
    ],
  },
  '/reports/attendance': {
    title: '出席・稼働レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '出席・稼働レポート' },
    ],
  },
  '/reports/staff': {
    title: 'コーチレポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: 'コーチレポート' },
    ],
  },
  '/reports/facilities': {
    title: '施設・設備レポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: '施設・設備レポート' },
    ],
  },
  '/reports/course-grade': {
    title: 'コース別人数一覧',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: 'コース別人数一覧' },
    ],
  },
  '/reports/custom': {
    title: 'カスタムレポート',
    icon: <IconChartBar size={20} />,
    breadcrumbs: [
      { label: 'レポート', path: '/reports' },
      { label: 'カスタムレポート' },
    ],
  },
};

interface MainLayoutProps {
  children: ReactNode;
  hideSidebar?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, hideSidebar = false }) => {
  const location = useLocation();
  const [pageConfig, setPageConfig] = useState<{
    title?: string;
    icon?: React.ReactNode;
    breadcrumbs?: { label: string; path?: string }[]
  }>({});

  useEffect(() => {
    // 現在のパスに基づいてページ設定を決定
    const currentPath = location.pathname;

    // 動的ルート（IDを含む）のパターンマッチング
    let matchedConfig = PAGE_CONFIG[currentPath];

    if (!matchedConfig) {
      // 動的ルートの処理
      if (currentPath.match(/\/master\/stores\/\d+\/edit$/)) {
        matchedConfig = {
          title: '店舗編集',
          icon: <IconBuilding size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '店舗管理', path: '/master/stores' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/stores\/\d+$/)) {
        matchedConfig = {
          title: '店舗詳細',
          icon: <IconBuilding size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '店舗管理', path: '/master/stores' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/staffs\/\d+\/edit$/)) {
        matchedConfig = {
          title: 'スタッフ編集',
          icon: <IconUsers size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'スタッフ管理', path: '/master/staffs' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/staffs\/\d+$/)) {
        matchedConfig = {
          title: 'スタッフ詳細',
          icon: <IconUsers size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'スタッフ管理', path: '/master/staffs' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/staffs\/new$/)) {
        matchedConfig = {
          title: '新規スタッフ登録',
          icon: <IconUsers size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'スタッフ管理', path: '/master/staffs' },
            { label: '新規登録' },
          ],
        };
      } else if (currentPath.match(/\/master\/program-categories\/\d+\/edit$/)) {
        matchedConfig = {
          title: 'プログラムカテゴリ編集',
          icon: <IconCategory size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラムカテゴリ管理', path: '/master/program-categories' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/program-categories\/\d+$/)) {
        matchedConfig = {
          title: 'プログラムカテゴリ詳細',
          icon: <IconCategory size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラムカテゴリ管理', path: '/master/program-categories' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/program-categories\/new$/)) {
        matchedConfig = {
          title: '新規プログラムカテゴリ登録',
          icon: <IconCategory size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラムカテゴリ管理', path: '/master/program-categories' },
            { label: '新規登録' },
          ],
        };
      } else if (currentPath.match(/\/master\/programs\/\d+\/edit$/)) {
        matchedConfig = {
          title: 'プログラム編集',
          icon: <IconCalendarEvent size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラム管理', path: '/master/programs' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/programs\/\d+$/)) {
        matchedConfig = {
          title: 'プログラム詳細',
          icon: <IconCalendarEvent size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラム管理', path: '/master/programs' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/programs\/new$/)) {
        matchedConfig = {
          title: '新規プログラム登録',
          icon: <IconCalendarEvent size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: 'プログラム管理', path: '/master/programs' },
            { label: '新規登録' },
          ],
        };
      } else if (currentPath.match(/\/master\/facilities\/\d+\/edit$/)) {
        matchedConfig = {
          title: '施設編集',
          icon: <IconBuildingWarehouse size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '施設管理', path: '/master/facilities' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/facilities\/\d+$/)) {
        matchedConfig = {
          title: '施設詳細',
          icon: <IconBuildingWarehouse size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '施設管理', path: '/master/facilities' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/facilities\/new$/)) {
        matchedConfig = {
          title: '新規施設登録',
          icon: <IconBuildingWarehouse size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '施設管理', path: '/master/facilities' },
            { label: '新規登録' },
          ],
        };
      } else if (currentPath.match(/\/master\/grades\/\d+\/edit$/)) {
        matchedConfig = {
          title: '級マスタ編集',
          icon: <IconMedal size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '級マスタ管理', path: '/master/grades' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/master\/grades\/\d+$/)) {
        matchedConfig = {
          title: '級マスタ詳細',
          icon: <IconMedal size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '級マスタ管理', path: '/master/grades' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/master\/grades\/new$/)) {
        matchedConfig = {
          title: '新規級マスタ登録',
          icon: <IconMedal size={20} />,
          breadcrumbs: [
            { label: 'マスター管理', path: '/master' },
            { label: '級マスタ管理', path: '/master/grades' },
            { label: '新規登録' },
          ],
        };
      } else if (currentPath.match(/\/billing\/cycles\/\d+\/edit$/)) {
        matchedConfig = {
          title: '請求サイクル編集',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: '請求サイクル管理', path: '/billing' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/billing\/cycles\/\d+$/)) {
        matchedConfig = {
          title: '請求サイクル詳細',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: '請求サイクル管理', path: '/billing' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/billing\/adjustments\/\d+\/edit$/)) {
        matchedConfig = {
          title: '料金調整編集',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: '料金調整マスタ', path: '/billing/adjustments' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/billing\/adjustments\/\d+$/)) {
        matchedConfig = {
          title: '料金調整詳細',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: '料金調整マスタ', path: '/billing/adjustments' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/discount-groups\/\d+\/edit$/)) {
        matchedConfig = {
          title: 'グループ編集',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: 'グループマスタ', path: '/discount-groups' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/discount-groups\/\d+$/)) {
        matchedConfig = {
          title: 'グループ詳細',
          icon: <IconCoin size={20} />,
          breadcrumbs: [
            { label: '請求管理', path: '/billing' },
            { label: 'グループマスタ', path: '/discount-groups' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/customers\/\d+\/edit$/)) {
        matchedConfig = {
          title: '顧客編集',
          icon: <IconUsers size={20} />,
          breadcrumbs: [
            { label: '顧客管理', path: '/customers' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/customers\/\d+$/)) {
        matchedConfig = {
          title: '顧客詳細',
          icon: <IconUsers size={20} />,
          breadcrumbs: [
            { label: '顧客管理', path: '/customers' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/bulletin-boards\/\d+\/edit$/)) {
        matchedConfig = {
          title: '掲示板編集',
          icon: <IconMessage size={20} />,
          breadcrumbs: [
            { label: '掲示板', path: '/bulletin-boards' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/bulletin-boards\/\d+$/)) {
        matchedConfig = {
          title: '掲示板詳細',
          icon: <IconMessage size={20} />,
          breadcrumbs: [
            { label: '掲示板', path: '/bulletin-boards' },
            { label: '詳細' },
          ],
        };
      } else if (currentPath.match(/\/chat\/\d+$/)) {
        matchedConfig = {
          title: 'チャットルーム',
          icon: <IconMessageCircle size={20} />,
          breadcrumbs: [
            { label: 'チャット', path: '/chat' },
            { label: 'ルーム' },
          ],
        };
      } else if (currentPath.match(/\/customer-pre-registrations\/\d+\/edit$/)) {
        matchedConfig = {
          title: '事前登録編集',
          icon: <IconUserPlus size={20} />,
          breadcrumbs: [
            { label: '事前登録管理', path: '/customer-pre-registrations' },
            { label: '編集' },
          ],
        };
      } else if (currentPath.match(/\/customer-pre-registrations\/\d+$/)) {
        matchedConfig = {
          title: '事前登録詳細',
          icon: <IconUserPlus size={20} />,
          breadcrumbs: [
            { label: '事前登録管理', path: '/customer-pre-registrations' },
            { label: '詳細' },
          ],
        };
      }
    }

    setPageConfig(matchedConfig || {});
  }, [location.pathname]);

  return (
    <AppLayout
      title={pageConfig.title}
      icon={pageConfig.icon}
      breadcrumbs={pageConfig.breadcrumbs}
      hideSidebar={hideSidebar}
    >
      {children}
    </AppLayout>
  );
};